import React from "react";
import Footer from "../components/Footer/Footer";
import Hero2 from "../components/Hero2/Hero2";
import Navbar from "../components/Navbar/Navbar";
import AboutUsImg from "../assets/About_Us_Photo.jpg";
import AboutUsSection1 from "../components/AboutUs/AboutUsSection1/AboutUsSection1";
import AboutUsSection2 from "../components/AboutUs/AboutUsSection2/AboutUsSection2";
import AboutUsSection3 from "../components/AboutUs/AboutUsSection3/AboutUsSection3";
import AboutUsSection4 from "../components/AboutUs/AboutUsSection4/AboutUsSection4";
import { useTranslation } from "react-i18next";
import SEO from "../components/SEO";
import "../App.css";

const About = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <SEO slug="AboutUs" />
      <Navbar />
      <Hero2
        cName="about-us-hero2"
        heroImg={AboutUsImg}
        title={t("pages.about.title")}
        text={t("pages.about.text")}
      />
      <AboutUsSection1 />
      <AboutUsSection2 />
      <AboutUsSection3 />
      <AboutUsSection4 />
      <Footer />
    </>
  );
};

export default About;
